import Api from './Api';

const END_POINT = "prosecution";

export default {
  async get_all(filters = null) {
    let request = {
      params: filters,
    };
    return await Api.get(`${END_POINT}`, request);
  },
  async get_allPaginated(filters = null) {
    let request = {
        params: filters
    }
    return await Api.get(`${END_POINT}-list-paginated`, request);
},
  async getSaleByOrden(filters = null) {
    let request = {
      params: filters,
    };
    return await Api.get("sale/getByOrden", request);
  },
  async store(analysis) {
    return await Api.post(`${END_POINT}`, analysis);
  },
  async update(analysis) {
    return await Api.patch(`${END_POINT}/${analysis.id}`, analysis);
  },
  async change_status(analysis) {
    return await Api.patch(
      `${END_POINT}/${analysis.id}/change-status`,
      analysis
    );
  },
  async delete(analysis) {
    return await Api.delete(`${END_POINT}/${analysis.id}`, analysis);
  },
};
